import type { NavigationRoutingAdditionalConfiguration } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

/**
 * Audience-nav heading for suppression lists / suppression rules.
 *
 * @param t dashboard-navigation translator
 * @param props NRO config; `featureOn` selects the umbrella "Suppressions" label
 * @returns localized heading
 */
export const suppressionListsNroHeading = (
  t: I18nT<"dashboard-navigation">,
  { featureOn }: NavigationRoutingAdditionalConfiguration
): string => {
  if (featureOn("suppression_rules")) {
    return t("suppressions-nro-heading", "Suppressions");
  }

  return t("suppression-lists-nro-heading", "Suppression Lists");
};

/**
 * Analytics page name for suppression list and rule routes.
 *
 * @param props NRO config; `featureOn` selects "Suppressions" so events correlate with the renamed nav item
 * @returns unlocalized tracking page name
 */
export const suppressionListsPageNameForTracking = ({
  featureOn,
}: NavigationRoutingAdditionalConfiguration): string => {
  if (featureOn("suppression_rules")) {
    return "Suppressions";
  }

  return "Suppression Lists";
};
